export const MODULE_1_INPUT = 'MODULE_1_INPUT'
export const MISC_DATA = 'MISC_DATA'
export const SET_SELECTED_DATA = 'SET_SELECTED_DATA'
export const DISPLAY_INFO = 'DISPLAY_INFO'
export const GET_FINANCIAL_STATEMENT = 'GET_FINANCIAL_STATEMENT'
export const DELETE_FINANCIAL_STATMENT = 'DELETE_FINANCIAL_STATMENT'



// WEBPACK FOOTER //
// ./src/actions/transformation_input_one.js